import ProfileVue from '@/views/sic/profile/profileComponent.vue';

const basePath = '/sic/profile';
const role = 'sic'; // 角色身份

export const SIC_PROFILE_INDEX = 'sic-profile-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ProfileVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_PROFILE_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/profile/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
